module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"headline":"Dažniausiai užduodami klausimai","unanswered":{"title":"Neradote atsakymo į savo klausimą?","subtitle":"Klauskite mūsų eksperto!","contact":"Susisiekti"}}}')
  delete Component.options._Ctor
}
